import { render } from "./HomePage.vue?vue&type=template&id=670a5132"
import script from "./HomePage.js?vue&type=script&lang=js"
export * from "./HomePage.js?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/korean-handbook/korean-handbook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__